import Image from 'next/image'
import Link from './../../Button'
import styles from './ActionableInsights.module.scss'

const InsightCard = ({ logo, headline, content, link, index }) => (
  <div className={styles.insight}>
    <div className={styles.image}>
      {logo && <Image src={logo.node.sourceUrl} alt={logo.node.altText || `Insight ${index} Logo`} width={127} height={127} />}
    </div>
    <div className={styles.actionableContent}>
      <h3 className={styles.headline}>{headline}</h3>
      <div className={styles.actionableCopy} dangerouslySetInnerHTML={{ __html: content }} />
      {link?.url && (
        <Link className={styles.actionableLink} href={link?.url} target={link?.target || '_self'}>
          {link?.title || 'Learn More'}
        </Link>
      )}
    </div>
  </div>
)

export default function ActionableInsights({ fields }) {
  const insights = [
    {
      logo: fields.insightOneLogo,
      headline: fields.insightOneHeadline,
      content: fields.insightOneContent,
      link: fields.insightOneLink
    },
    {
      logo: fields.insightTwoLogo,
      headline: fields.insightTwoHeadline,
      content: fields.insightTwoContent,
      link: fields.insightTwoLink
    },
    {
      logo: fields.insightThreeLogo,
      headline: fields.insightThreeHeadline,
      content: fields.insightThreeContent,
      link: fields.insightThreeLink
    }
  ]

  return (
    <div className={styles.actionableInsights} data-aos="fade-up">
      <div className={styles.actionableInsightsWrapper}>
        <div className="container">
          {fields.headline && (
            <h2 data-aos="fade-up" style={{ textAlign: 'center' }}>
              {fields.headline}
            </h2>
          )}
          <div>
            <div className={styles.insights}>
              {insights.map((insight, index) => (
                <InsightCard
                  key={index}
                  logo={insight.logo}
                  headline={insight.headline}
                  content={insight.content}
                  link={insight.link}
                  index={index + 1}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
